// extracted by mini-css-extract-plugin
export default {"presentation":"leftBand_presentation__z2ZIK","title":"leftBand_title__Jzoag","deco":"leftBand_deco__xK0p8","copyright":"leftBand_copyright__PkmR7","link":"leftBand_link__jyz0M"};